<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="20" viewBox="0 0 20.5 20">
    <g transform="translate(-158 -577)">
      <g transform="translate(135 308)">
        <g transform="translate(2 33)">
          <path :style="{stroke:color}" class="a" d="M15,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H15" transform="translate(19 234)"/>
        </g>
      </g>
      <g transform="translate(-80 -5)">
        <path :style="{stroke:color}" class="b" d="M1,9S3.5,4,7.875,4,14.75,9,14.75,9s-2.5,5-6.875,5S1,9,1,9Z" transform="translate(243 583)"/>
        <circle :style="{stroke:color}" class="b" cx="2" cy="2" r="2" transform="translate(249 590)"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
name: "FindLeadsIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
  .a, .b {
    fill: none;
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .a {
    stroke-width: 2px;
  }

  .b {
    stroke-width: 1.5px;
  }
</style>
